import script from "./TeacherInformation2.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeacherInformation2.vue?vue&type=script&lang=ts&setup=true"

import "./TeacherInformation2.vue?vue&type=style&index=0&id=2b229f5c&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b229f5c"]])

export default __exports__